import { render, staticRenderFns } from "./Assessments.vue?vue&type=template&id=158c5dee&scoped=true"
import script from "./Assessments.vue?vue&type=script&lang=js"
export * from "./Assessments.vue?vue&type=script&lang=js"
import style0 from "./Assessments.vue?vue&type=style&index=0&id=158c5dee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c5dee",
  null
  
)

export default component.exports